import { withViewComponent } from '@updater-local/custom-element-v1';
import styles from './index.css';

class CoverageAreas extends withViewComponent(styles)() {
  static props = ['value'];

  updated({ value }) {
    this.render`
      ${value.map(
        coverage => `
          <span class="coverage">${coverage.city}, ${coverage.state}</span>
        `
      )}
    `;
  }
}

customElements.define('upd-moveiq-company-coverage-areas', CoverageAreas);
